import { useContext } from 'react'
import { SelectedRecordNameContext, SelectedRecordNameDispatchContext } from './context'

export function useSelectedRecordName() {
  const context = useContext(SelectedRecordNameContext)
  if (context === undefined) {
    throw new Error(
      'useSelectedRecordName must be used within a SelectedRecordNameProvider'
    )
  }
  return context
}

export function useSelectedRecordNameDispatch() {
  const context = useContext(SelectedRecordNameDispatchContext)
  if (context === undefined) {
    throw new Error(
      'useSelectedRecordNameDispatch must be used within a SelectedRecordNameProvider'
    )
  }
  return context
}
